import Button from 'devextreme-react/button';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';
import { useSavePostInstallCallScriptForm } from '../api/save-postInstallCallScriptForm';

const PostInstallCallScriptForm: React.FC<{
    retailOrderID: number,
    retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> = ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {
    const [anyProblemCheckBox, setAnyProblemCheckBox] = useState(false);
    const [askCustomerCheckBox, setAskCustomerCheckBox] = useState(false);
    const [congratulateCheckBox, setCongratulateCheckBox] = useState(false);
    const [finishedPicturesCheckBox, setFinishedPicturesCheckBox] = useState(false);
    const [ifNoCheckBox, setIfNoCheckBox] = useState(false);
    const [ifYesCheckBox, setIfYesCheckBox] = useState(false);
    const [lastChanceCheckBox, setLastChanceCheckBox] = useState(false);
    const [lowesSurveyPerfectCheckBox, setLowesSurveyPerfectCheckBox] = useState(false);
    const [offerCheckBox, setOfferCheckBox] = useState(false);
    const [thankCheckBox, setThankCheckBox] = useState(false);
    const [brieflyExplainText, setBrieflyExplainText] = useState('');
    const [mayISpeakToCheckBox, setMayISpeakToCheckBox] = useState(false);
    const [introduceYourselfCheckBox, setIntroduceYourselfCheckBox] = useState(false);
    const [noteText, setNoteText] = useState('');

    const savePostInstallCallScriptForm = useSavePostInstallCallScriptForm(
        {
            formObject: {
                RetailOrderID: retailOrderID,
                RetailOrderNo: retailOrderNumber,
                AnyProblemCheckBox: anyProblemCheckBox,
                AskCustomerCheckBox: askCustomerCheckBox,
                CongratulateCheckBox: congratulateCheckBox,
                FinishedPicturesCheckBox: finishedPicturesCheckBox,
                IfNoCheckBox: ifNoCheckBox,
                IfYesCheckBox: ifYesCheckBox,
                LastChanceCheckBox: lastChanceCheckBox,
                LowesSurveyPerfectCheckBox: lowesSurveyPerfectCheckBox,
                OfferCheckBox: offerCheckBox,
                ThankCheckBox: thankCheckBox,
                BrieflyExplainText: brieflyExplainText,
                MayISpeakToCheckBox: mayISpeakToCheckBox,
                IntroduceYourselfCheckBox: introduceYourselfCheckBox,
                NoteText: noteText
            }
        },
        (result) => {
            onClosePopup();
            onCheckboxChange(true);
            if (onSubmit !== undefined) onSubmit!();
        },
        (error) => showErrorMessage(error)
    );

    const handleBrieflyExplainText = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setBrieflyExplainText(event.target.value);
    };

    const handleReset = () => {
        setAnyProblemCheckBox(false);
        setAskCustomerCheckBox(false);
        setCongratulateCheckBox(false);
        setFinishedPicturesCheckBox(false);
        setIfNoCheckBox(false);
        setIfYesCheckBox(false);
        setLastChanceCheckBox(false);
        setLowesSurveyPerfectCheckBox(false);
        setOfferCheckBox(false);
        setThankCheckBox(false);
        setBrieflyExplainText('');
        setMayISpeakToCheckBox(false);
        setIntroduceYourselfCheckBox(false);
        setNoteText('');
    };

    const handleNoteText = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNoteText(event.target.value);
    };

    return (
        <div>
            <div className='main-header'>
                <h1>Project Manager - Post Install Call Checklist</h1>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Greeting</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={mayISpeakToCheckBox} onChange={(e) => setMayISpeakToCheckBox(e.target.checked)} />
                        “May I speak to (customer name)”
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={introduceYourselfCheckBox} onChange={(e) => setIntroduceYourselfCheckBox(e.target.checked)} />
                        Introduce yourself, your company – in partnership with Lowe’s, and that you’re calling to
                        schedule their installation appointment for their Lowe’s countertop project.
                    </label>
                </div>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Post Install Call – Call Day After Install</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={congratulateCheckBox} onChange={(e) => setCongratulateCheckBox(e.target.checked)} />
                        Congratulate them on the completion of their countertop project
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={askCustomerCheckBox} onChange={(e) => setAskCustomerCheckBox(e.target.checked)} />
                        Ask customer how countertop project went with (installer’s name) – let customer talk.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={anyProblemCheckBox} onChange={(e) => setAnyProblemCheckBox(e.target.checked)} />
                        If any problems, take actions to resolve
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={finishedPicturesCheckBox} onChange={(e) => setFinishedPicturesCheckBox(e.target.checked)} />
                        Ask for finished pictures – “love to see your finished project!”
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={lastChanceCheckBox} onChange={(e) => setLastChanceCheckBox(e.target.checked)} />
                        Last chance of <b>Granite Gold</b> conversation if not already purchased (30 day from install)
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={lowesSurveyPerfectCheckBox} onChange={(e) => setLowesSurveyPerfectCheckBox(e.target.checked)} />
                        <b>Lowe’s survey perfect score expectation</b> – “serves as our report card and only scored on a
                        perfect 10.”
                    </label>
                    <div className='section-row-section-hint-italic'>
                        » “Lowe’s will be contacting you via email or text with a link to the survey in the next few
                        days. Delivering a 10-star countertop experience is our aim, and we’re eager to earn your
                        recommendation through our report card. Your feedback is invaluable in helping us achieve
                        perfection. Have we earned a perfect 10 on your countertop project? We always strive for
                        excellence, so if there’s any reason why we haven’t met your expectations on your countertop
                        project, please let me know.”
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={ifYesCheckBox} onChange={(e) => setIfYesCheckBox(e.target.checked)} />
                        If they say yes, move to the lines below
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={ifNoCheckBox} onChange={(e) => setIfNoCheckBox(e.target.checked)} />
                        If they say no, ask them what is the reason and how you can address it
                    </label>
                    <div className='section-row-section-hint'>
                        <textarea
                            className='input-fullsize'
                            value={brieflyExplainText}
                            onChange={handleBrieflyExplainText}
                            placeholder="If &quot;No&quot;, Briefly explain reason customer is dissatisfied"
                            rows={5}
                            cols={40}
                        />
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={thankCheckBox} onChange={(e) => setThankCheckBox(e.target.checked)} />
                        Thank them for choosing your countertops and for their trust in delivering the (area of home,
                        kitchen, bath etc.) of their dreams!
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={offerCheckBox} onChange={(e) => setOfferCheckBox(e.target.checked)} />
                        Offer your contact information if they have any questions in the future about their countertops
                    </label>
                </div>
                <div className='section-row'>
                    Notes:
                    <textarea
                        className='input-fullsize-large-height'
                        value={noteText}
                        onChange={handleNoteText}
                        placeholder="Note"
                        rows={5}
                        cols={40}
                    />
                </div>
            </div>

            <div className='button-container'>
                <Button
                    text="Reset"
                    className='reset-button'
                    type="danger"
                    onClick={(e) => {
                        handleReset()
                    }} >
                </Button>

                <Button
                    text="Save Changes"
                    className="save-button"
                    onClick={(e) => {
                        savePostInstallCallScriptForm.mutate();
                    }} >
                </Button>
            </div>
        </div>
    );
};

export default PostInstallCallScriptForm;
